module.exports = __webpack_public_path__ + "media/images/takashimaya_watchmason-7aba12df3096350e745793180658f6b7.jpg";